import axiosHttp from "services/axiosHttp";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

//CREATE ACTION
export const approveRequest = createAsyncThunk("approveRequest", async (data, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`approvals/approve-many`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const ApproveRequestsSlice = createSlice({
	name: "ApproveRequestsSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetRequestApproveState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(approveRequest.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(approveRequest.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(approveRequest.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetRequestApproveState } = ApproveRequestsSlice.actions;
export default ApproveRequestsSlice.reducer;
